import { Effect, Reducer } from '@umijs/max';

// services
import { getBanks } from '@/services/banks.service';
import { getRepresentative } from '@/services/representatives.service';

// interfaces
import { Bank } from '@/interfaces/banks';
import { AffiliateRepresentationType } from '@/interfaces/affiliates';
import { redirectNotFound } from '@/utils/errorRedirect';

export interface ModelType {
  namespace: string;

  state: { representation: null | AffiliateRepresentationType; banks: Bank[] };

  effects: {
    sendHistory: Effect;
    fetchRepresentativeDetail: Effect;
  };

  reducers: {
    setRepresentative: Reducer<any>;
    setHistory: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'representantDetail',

  state: {
    banks: [],
    representation: null,
  },

  effects: {
    *fetchRepresentativeDetail({ payload }, { call, put, all }) {
      try {
        const [representation, banks] = yield all([
          call(getRepresentative, payload),
          call(getBanks, payload),
        ]);
        yield put({
          type: 'setRepresentative',
          payload: {
            representation: representation.data,
            banks: banks.data,
          },
        });
      } 
      catch (error) {
        redirectNotFound(error);
      }
    },

    *sendHistory({ payload }) {
      yield {
        type: 'setHistory',
        payload,
      };
    },
  },

  reducers: {
    setRepresentative(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setHistory(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
